module.exports = __webpack_public_path__ + "static/img/brazil_flag.39ebe40.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/brazil_flag.png
// module id = 8Z3u
// module chunks = 1